import type { DayLogs, Food, MealSet, User } from "../api/client";
import { todayLocalDate } from "./date";

const PREVIEW_PARAM = "preview";

export function isTodayPreviewMode(): boolean {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  const isLocalHost = hostname === "127.0.0.1" || hostname === "localhost";
  if (!isLocalHost) return false;
  const params = new URLSearchParams(window.location.search);
  return params.get(PREVIEW_PARAM) === "today";
}

export function getPreviewUser(): User {
  return {
    id: "preview-user",
    name: "Preview User",
    email: "preview@example.com",
    daily_target_kcal: 2600,
    default_daily_target_kcal: 2600,
    target_configured: true,
  };
}

export async function getPreviewResponse<T>(path: string, init: RequestInit = {}): Promise<T | undefined> {
  const method = (init.method ?? "GET").toUpperCase();
  const url = new URL(path, "http://preview.local");
  const pathname = url.pathname;

  if (method === "GET" && pathname === "/users/me") {
    return getPreviewUser() as T;
  }

  if (method === "GET" && pathname === "/foods") {
    const q = (url.searchParams.get("q") ?? "").trim().toLocaleLowerCase();
    const foods = getPreviewFoods().filter((food) =>
      q.length === 0 ? true : food.name.toLocaleLowerCase().includes(q)
    );
    return foods as T;
  }

  if (method === "GET" && pathname === "/sets") {
    return getPreviewSets() as T;
  }

  if (method === "GET" && pathname === "/meal-logs") {
    return getPreviewDayLogs() as T;
  }

  return undefined;
}

function getPreviewFoods(): Food[] {
  return [
    { id: "food-1", name: "プロテイン", kcal: 120, use_count: 12, last_used_at: null },
    { id: "food-2", name: "かなブレッド", kcal: 320, use_count: 8, last_used_at: null },
    { id: "food-3", name: "サラダチキン", kcal: 145, use_count: 6, last_used_at: null },
  ];
}

function getPreviewSets(): MealSet[] {
  return [
    {
      id: "set-1",
      name: "朝セット",
      use_count: 3,
      last_used_at: null,
      total_kcal: 430,
      items: [
        { id: "set-item-1", food_id: "food-1", food_name: "プロテイン", kcal: 120 },
        { id: "set-item-2", food_id: "food-2", food_name: "かなブレッド", kcal: 310 },
      ],
    },
  ];
}

function getPreviewDayLogs(): DayLogs {
  return {
    date: todayLocalDate(),
    total_kcal: 1465,
    target_kcal: 2600,
    logs: [
      {
        id: "log-1",
        eaten_at: `${todayLocalDate()}T07:30:00+09:00`,
        food_name: "プロテイン",
        kcal: 120,
        media: [],
      },
    ],
  };
}